export default __webpack_public_path__ + "static/media/github.e0df113a.svg";